import { render, staticRenderFns } from "./Cost.vue?vue&type=template&id=2d4a3740&scoped=true&"
import script from "./Cost.vue?vue&type=script&lang=js&"
export * from "./Cost.vue?vue&type=script&lang=js&"
import style0 from "./Cost.vue?vue&type=style&index=0&id=2d4a3740&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4a3740",
  null
  
)

export default component.exports